'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var busca = exports.busca = 'https://m.olx.com.br/busca';
var meusAnuncios = exports.meusAnuncios = 'https://m2.olx.com.br/contas/meus_anuncios';
var chat = exports.chat = 'https://conta.olx.com.br/chats';
var inserirAnuncio = exports.inserirAnuncio = 'https://m2.olx.com.br/inserir/ad_form/0';
var sair = exports.sair = 'https://m2.olx.com.br/contas/logout';